import { useInfiniteQuery } from '@tanstack/react-query'
import React, { useCallback, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { selectCreditCard } from 'src/app/AccountOverview/redux/accountOverview.selectors'
import BackgroundPageContent from 'src/components/BackgroundPageContent/BackgroundPageContent'
import Box from 'src/components/Box/Box'
import BudgetHistoryTable from 'src/components/BudgetHistoryTable/BudgetHistoryTable'
import { useBackgroundDispatch } from 'src/hooks'
import { useBackgroundLocation } from 'src/navigation/backgroundLocation'
import { getAccountHistoryCreditCardId } from 'src/navigation/backgroundRouteParams'
import { connectedReplace } from 'src/navigation/Lnk'
import { budgetHistoryUrl } from 'src/navigation/urls'
import {
  budgetRevisionsQueries,
  selectBudgetRevisionListModels,
} from 'src/queries/creditCards/budgetRevisions/budgetRevisions.queries'
import { selectUserIdFromState } from 'src/redux/selectors/auth.selectors'
import { css } from 'styled-components'

const AccountHistory: React.FC = () => {
  const dispatch = useBackgroundDispatch()
  const backgroundLocation = useBackgroundLocation()
  const creditCardId = getAccountHistoryCreditCardId(backgroundLocation)
  const userId = useSelector(selectUserIdFromState)
  const creditCard = useSelector(selectCreditCard)

  const revisionsQuery = useInfiniteQuery({
    ...budgetRevisionsQueries.list(creditCardId, { limit: 5 }),
    select: selectBudgetRevisionListModels,
  })
  const { fetchNextPage, hasNextPage, isFetchingNextPage } = revisionsQuery

  const fetchMoreRevisions = useCallback((): void => {
    if (hasNextPage && !isFetchingNextPage) {
      void fetchNextPage()
    }
  }, [fetchNextPage, hasNextPage, isFetchingNextPage])

  // redirect to budget history if budget
  useEffect(() => {
    if (creditCard?.isBudget) {
      dispatch(connectedReplace(budgetHistoryUrl(creditCard.id)))
    }
  }, [creditCard])

  return (
    <BackgroundPageContent
      css={css`
        padding: 40px 80px;
      `}
    >
      <Box noPadding>
        <BudgetHistoryTable
          revisions={revisionsQuery.data ?? []}
          userId={userId}
          timezone={creditCard?.timezone}
          currency={creditCard?.currency}
          fetchMoreRevisions={fetchMoreRevisions}
          fullyLoadedRevisions={hasNextPage === false}
          revisionsLoading={revisionsQuery.isFetching}
        />
      </Box>
    </BackgroundPageContent>
  )
}

export default AccountHistory
